import {IGraphAxis, IGraphMetric} from "../PA.UIM.Metric/PA.UIM.Graph.IF";

import {
  CNSMP_LIST_PRICE,
  CNSMP_RETAILER_AVG_PRICE,
  CNSMP_RETAILER_PROMOTED_PRICE, StdMerchadisingACVAxis, StdMerchadisingUnitsAxis, StdPricesAxis, StdUnitsAxis
} from "../PA.UIM.Metric/StandardGraphComponents";


//
// Define Metrics for each Axis
//


//<editor-fold desc="Cannibalization Set - Consumer Units Axis">

//<editor-fold desc="Cannibalization Set - Consumer Units Axis - Metrics">


const CNSMP_INCR_UNITS_UseBounds_Cannib: IGraphMetric = {
  id: "CNSMP_INCR_UNITS_UseBounds_Cannib",
  name: "Incr Units",
  sort: 20,
  renderOptions: {},
  components: [
    {id: "CNSMP_INCR_UNITS_InsideBounds_Cannib",
      name: "InsideBounds Incr Units",
      metricFieldName: "CNSMP_INCR_UNITS",
      periodMetricsPath: "CalcInsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_INCR_UNITS_InsideBounds_Cannib": '*'},
            properties: {color : "#CFF4C9"},
            displayName: "InsideBounds Incr Units"
          }
        }
      }
    },
    {id: "CNSMP_INCR_UNITS_OutsideBounds_Cannib",
      name: "OutsideBounds Incr Units",
      metricFieldName: "CNSMP_INCR_UNITS",
      periodMetricsPath: "CalcOutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_INCR_UNITS_OutsideBounds_Cannib": '*'},
            properties: {color : "#CFF4C9",  pattern : "diagonalLightStripe"},
            displayName: "OutsideBounds Incr Units"
          }
        }
      }
    }
  ]
}


const CNSMP_BASE_UNITS_UseBounds_Cannib: IGraphMetric = {
  id: "CNSMP_BASE_UNITS_UseBounds_Cannib",
  name: "Base Units",
  sort: 40,
  renderOptions: {},
  components: [
    {id: "CNSMP_BASE_UNITS_InsideBounds_Cannib",
      name: "InsideBounds Base Units",
      metricFieldName: "CNSMP_BASE_UNITS",
      periodMetricsPath: "CalcInsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_BASE_UNITS_InsideBounds_Cannib": '*'},
            properties: {color : "#A59487"},
            displayName: "InsideBounds Base Units"
          }
        }
      }
    },
    {id: "CNSMP_BASE_UNITS_OutsideBounds_Cannib",
      name: "OutsideBounds Base Units",
      metricFieldName: "CNSMP_BASE_UNITS",
      periodMetricsPath: "CalcOutsideBounds",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_BASE_UNITS_OutsideBounds_Cannib": '*'},
            properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
            displayName: "OutsideBounds Base Units"
          }
        }
      }
    }
  ]
}


const CNSMP_CANNIB_VICT_UNITS_Cannib: IGraphMetric = {
  id: "CNSMP_CANN_VCTM_UNITS_Cannib",
  name: "Cann Victim Units",
  sort: 30,
  renderOptions: {},
  components: [
    {id: "CNSMP_CANN_VCTM_UNITS_Cannib",
      name: "Cann Victim Units",
      metricFieldName: "CNSMP_CANN_VCTM_UNITS",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_CANN_VCTM_UNITS_Cannib": '*'},
            properties: {color : "#a52f1b"},
            displayName: "Cann Victim Units"
          }
        }
      }
    }
  ]
}

const CNSMP_CANNIB_AGGR_UNITS_Cannib: IGraphMetric = {
  id: "CNSMP_CANN_AGGR_UNITS_Cannib",
  name: "Cann Aggressor Units",
  sort: 30,
  renderOptions: {},
  components: [
    {id: "CNSMP_CANN_AGGR_UNITS_Cannib",
      name: "Cann Aggressor Units",
      metricFieldName: "CNSMP_CANN_AGGR_UNITS",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"CNSMP_CANN_AGGR_UNITS_Cannib": '*'},
            properties: {color : "#e69b2f"},
            displayName: "Cann Aggressor Units"
          }
        }
      }
    }
  ]
}


//</editor-fold>

export const  CannibalizationSetUnitsAxis: IGraphAxis = {
  id: "Cann_Consumer_Units",
  name: "Consumer Units Cnb",
  renderOptions: {ui5: {
      resourceName: "CannibalizationConsumerUnitsAxisName",
      vizPropertiesAxis: {
        title: {
          visible: true,
          text: "Consumer Units"
        }
      },
      vizPropertiesPlotArea: {}
    }
  },
  metrics: [CNSMP_CANNIB_VICT_UNITS_Cannib,
            CNSMP_CANNIB_AGGR_UNITS_Cannib,
            CNSMP_INCR_UNITS_UseBounds_Cannib,
            CNSMP_BASE_UNITS_UseBounds_Cannib],
  defaultRenderedMetricIds: [
    CNSMP_CANNIB_VICT_UNITS_Cannib.id,
    CNSMP_INCR_UNITS_UseBounds_Cannib.id,
    CNSMP_BASE_UNITS_UseBounds_Cannib.id
  ]

}

//</editor-fold>

//<editor-fold desc="Cannibalization Set - Retailer Sales Axis">

//<editor-fold desc="Cannibalization Set - Retailer Sales Axis - Metrics">


const CNSMP_INCR_RTLSLS_UseBounds_Cannib: IGraphMetric = {
    id: "CNSMP_INCR_RTLSLS_UseBounds_Cannib",
    name: "Retail Sales",
    sort: 20,
    renderOptions: {},
    components: [
        {id: "CNSMP_INCR_RTLSLS_InsideBounds_Cannib",
            name: "InsideBounds Retail Sales",
            metricFieldName: "CNSMP_INCR_RTLSLS",
            periodMetricsPath: "CalcInsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_RTLSLS_InsideBounds_Cannib": '*'},
                        properties: {color : "#CFF4C9"},
                        displayName: "InsideBounds Retail Sales"
                    }
                }
            }
        },
        {id: "CNSMP_INCR_RTLSLS_OutsideBounds_Cannib",
            name: "OutsideBounds Retail Sales",
            metricFieldName: "CNSMP_INCR_RTLSLS",
            periodMetricsPath: "CalcOutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_RTLSLS_OutsideBounds_Cannib": '*'},
                        properties: {color : "#CFF4C9",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Retail Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_RTLSLS_UseBounds_Cannib: IGraphMetric = {
    id: "CNSMP_BASE_RTLSLS_UseBounds_Cannib",
    name: "Base Retail Sales",
    sort: 40,
    renderOptions: {},
    components: [
        {id: "CNSMP_BASE_RTLSLS_InsideBounds_Cannib",
            name: "InsideBounds Base Retail Sales",
            metricFieldName: "CNSMP_BASE_RTLSLS",
            periodMetricsPath: "CalcInsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_RTLSLS_InsideBounds_Cannib": '*'},
                        properties: {color : "#A59487"},
                        displayName: "InsideBounds Base Retail Sales"
                    }
                }
            }
        },
        {id: "CNSMP_BASE_RTLSLS_OutsideBounds_Cannib",
            name: "OutsideBounds Base Retail Sales",
            metricFieldName: "CNSMP_BASE_RTLSLS",
            periodMetricsPath: "CalcOutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_RTLSLS_OutsideBounds_Cannib": '*'},
                        properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Base Retail Sales"
                    }
                }
            }
        }
    ]
}


const CNSMP_CANNIB_VICT_RTLSLS_Cannib: IGraphMetric = {
    id: "CNSMP_CANN_VCTM_RTLSLS_Cannib",
    name: "Cann Victim Retail Sales",
    sort: 30,
    renderOptions: {},
    components: [
        {id: "CNSMP_CANN_VCTM_RTLSLS_Cannib",
            name: "Cann Victim Retail Sales",
            metricFieldName: "CNSMP_CANN_VCTM_RTLSLS",
            periodMetricsPath: "CalcTotal",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_CANN_VCTM_RTLSLS_Cannib": '*'},
                        properties: {color : "#a52f1b"},
                        displayName: "Cann Victim Retail Sales"
                    }
                }
            }
        }
    ]
}

const CNSMP_CANNIB_AGGR_RTLSLS_Cannib: IGraphMetric = {
    id: "CNSMP_CANN_AGGR_RTLSLS_Cannib",
    name: "Cann Aggressor Retail Sales",
    sort: 30,
    renderOptions: {},
    components: [
        {id: "CNSMP_CANN_AGGR_RTLSLS_Cannib",
            name: "Cann Aggressor Retail Sales",
            metricFieldName: "CNSMP_CANN_AGGR_RTLSLS",
            periodMetricsPath: "CalcTotal",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_CANN_AGGR_RTLSLS_Cannib": '*'},
                        properties: {color : "#e69b2f"},
                        displayName: "Cann Aggressor Retail Sales"
                    }
                }
            }
        }
    ]
}


//</editor-fold>

export const  CannibalizationSetRetailSalesAxis: IGraphAxis = {
    id: "Cann_Retail_Sales",
    name: "Retail Sales Cnb",
    renderOptions: {ui5: {
            resourceName: "CannibalizationRetailSalesAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Retail Sales"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_CANNIB_VICT_RTLSLS_Cannib,
        CNSMP_CANNIB_AGGR_RTLSLS_Cannib,
        CNSMP_INCR_RTLSLS_UseBounds_Cannib,
        CNSMP_BASE_RTLSLS_UseBounds_Cannib],
    defaultRenderedMetricIds: [
        CNSMP_CANNIB_VICT_RTLSLS_Cannib.id,
        CNSMP_INCR_RTLSLS_UseBounds_Cannib.id,
        CNSMP_BASE_RTLSLS_UseBounds_Cannib.id
    ]

}

//</editor-fold>

//<editor-fold desc="Cannibalization Set - Weight Axis">

//<editor-fold desc="Cannibalization Set - Weight Axis - Metrics">


const CNSMP_INCR_WT_UseBounds_Cannib: IGraphMetric = {
    id: "CNSMP_INCR_WT_UseBounds_Cannib",
    name: "Weight",
    sort: 20,
    renderOptions: {},
    components: [
        {id: "CNSMP_INCR_WT_InsideBounds_Cannib",
            name: "InsideBounds Weight",
            metricFieldName: "CNSMP_INCR_WT",
            periodMetricsPath: "CalcInsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_WT_InsideBounds_Cannib": '*'},
                        properties: {color : "#CFF4C9"},
                        displayName: "InsideBounds Weight"
                    }
                }
            }
        },
        {id: "CNSMP_INCR_WT_OutsideBounds_Cannib",
            name: "OutsideBounds Weight",
            metricFieldName: "CNSMP_INCR_WT",
            periodMetricsPath: "CalcOutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_WT_OutsideBounds_Cannib": '*'},
                        properties: {color : "#CFF4C9",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Weight"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_WT_UseBounds_Cannib: IGraphMetric = {
    id: "CNSMP_BASE_WT_UseBounds_Cannib",
    name: "Base Weight",
    sort: 40,
    renderOptions: {},
    components: [
        {id: "CNSMP_BASE_WT_InsideBounds_Cannib",
            name: "InsideBounds Base Weight",
            metricFieldName: "CNSMP_BASE_WT",
            periodMetricsPath: "CalcInsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_WT_InsideBounds_Cannib": '*'},
                        properties: {color : "#A59487"},
                        displayName: "InsideBounds Base Weight"
                    }
                }
            }
        },
        {id: "CNSMP_BASE_WT_OutsideBounds_Cannib",
            name: "OutsideBounds Base Weight",
            metricFieldName: "CNSMP_BASE_WT",
            periodMetricsPath: "CalcOutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_WT_OutsideBounds_Cannib": '*'},
                        properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Base Weight"
                    }
                }
            }
        }
    ]
}


const CNSMP_CANNIB_VICT_WT_Cannib: IGraphMetric = {
    id: "CNSMP_CANN_VCTM_WT_Cannib",
    name: "Cann Victim Weight",
    sort: 30,
    renderOptions: {},
    components: [
        {id: "CNSMP_CANN_VCTM_WT_Cannib",
            name: "Cann Victim Weight",
            metricFieldName: "CNSMP_CANN_VCTM_WT",
            periodMetricsPath: "CalcTotal",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_CANN_VCTM_WT_Cannib": '*'},
                        properties: {color : "#a52f1b"},
                        displayName: "Cann Victim Weight"
                    }
                }
            }
        }
    ]
}

const CNSMP_CANNIB_AGGR_WT_Cannib: IGraphMetric = {
    id: "CNSMP_CANN_AGGR_WT_Cannib",
    name: "Cann Aggressor Weight",
    sort: 30,
    renderOptions: {},
    components: [
        {id: "CNSMP_CANN_AGGR_WT_Cannib",
            name: "Cann Aggressor Weight",
            metricFieldName: "CNSMP_CANN_AGGR_WT",
            periodMetricsPath: "CalcTotal",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_CANN_AGGR_WT_Cannib": '*'},
                        properties: {color : "#e69b2f"},
                        displayName: "Cann Aggressor Weight"
                    }
                }
            }
        }
    ]
}


//</editor-fold>

export const  CannibalizationSetWeightAxis: IGraphAxis = {
    id: "Cann_Wt",
    name: "Weight Cnb",
    renderOptions: {ui5: {
            resourceName: "CannibalizationWeightAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Weight"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_CANNIB_VICT_WT_Cannib,
        CNSMP_CANNIB_AGGR_WT_Cannib,
        CNSMP_INCR_WT_UseBounds_Cannib,
        CNSMP_BASE_WT_UseBounds_Cannib],
    defaultRenderedMetricIds: [
        CNSMP_CANNIB_VICT_WT_Cannib.id,
        CNSMP_INCR_WT_UseBounds_Cannib.id,
        CNSMP_BASE_WT_UseBounds_Cannib.id
    ]

}

//</editor-fold>

//<editor-fold desc="Cannibalization Set - Standard Case Axis">

//<editor-fold desc="Cannibalization Set - Standard Case Axis - Metrics">


const CNSMP_INCR_STAT_UseBounds_Cannib: IGraphMetric = {
    id: "CNSMP_INCR_STAT_UseBounds_Cannib",
    name: "Statistical Case",
    sort: 20,
    renderOptions: {},
    components: [
        {id: "CNSMP_INCR_STAT_InsideBounds_Cannib",
            name: "InsideBounds Statistical Case",
            metricFieldName: "CNSMP_INCR_STAT",
            periodMetricsPath: "CalcInsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_STAT_InsideBounds_Cannib": '*'},
                        properties: {color : "#CFF4C9"},
                        displayName: "InsideBounds Statistical Case"
                    }
                }
            }
        },
        {id: "CNSMP_INCR_STAT_OutsideBounds_Cannib",
            name: "OutsideBounds Statistical Case",
            metricFieldName: "CNSMP_INCR_STAT",
            periodMetricsPath: "CalcOutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_INCR_STAT_OutsideBounds_Cannib": '*'},
                        properties: {color : "#CFF4C9",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Statistical Case"
                    }
                }
            }
        }
    ]
}


const CNSMP_BASE_STAT_UseBounds_Cannib: IGraphMetric = {
    id: "CNSMP_BASE_STAT_UseBounds_Cannib",
    name: "Base Statistical Case",
    sort: 40,
    renderOptions: {},
    components: [
        {id: "CNSMP_BASE_STAT_InsideBounds_Cannib",
            name: "InsideBounds Base Statistical Case",
            metricFieldName: "CNSMP_BASE_STAT",
            periodMetricsPath: "CalcInsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_STAT_InsideBounds_Cannib": '*'},
                        properties: {color : "#A59487"},
                        displayName: "InsideBounds Base Statistical Case"
                    }
                }
            }
        },
        {id: "CNSMP_BASE_STAT_OutsideBounds_Cannib",
            name: "OutsideBounds Base Statistical Case",
            metricFieldName: "CNSMP_BASE_STAT",
            periodMetricsPath: "CalcOutsideBounds",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_BASE_STAT_OutsideBounds_Cannib": '*'},
                        properties: {color : "#A59487",  pattern : "diagonalLightStripe"},
                        displayName: "OutsideBounds Base Statistical Case"
                    }
                }
            }
        }
    ]
}


const CNSMP_CANNIB_VICT_STAT_Cannib: IGraphMetric = {
    id: "CNSMP_CANN_VCTM_STAT_Cannib",
    name: "Cann Victim Statistical Case",
    sort: 30,
    renderOptions: {},
    components: [
        {id: "CNSMP_CANN_VCTM_STAT_Cannib",
            name: "Cann Victim Statistical Case",
            metricFieldName: "CNSMP_CANN_VCTM_STAT",
            periodMetricsPath: "CalcTotal",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_CANN_VCTM_STAT_Cannib": '*'},
                        properties: {color : "#a52f1b"},
                        displayName: "Cann Victim Statistical Case"
                    }
                }
            }
        }
    ]
}

const CNSMP_CANNIB_AGGR_STAT_Cannib: IGraphMetric = {
    id: "CNSMP_CANN_AGGR_STAT_Cannib",
    name: "Cann Aggressor Statistical Case",
    sort: 30,
    renderOptions: {},
    components: [
        {id: "CNSMP_CANN_AGGR_STAT_Cannib",
            name: "Cann Aggressor Statistical Case",
            metricFieldName: "CNSMP_CANN_AGGR_STAT",
            periodMetricsPath: "CalcTotal",
            renderOptions: {ui5: { dataShape: "bar",
                    dataPointRule: {
                        dataContext: {"CNSMP_CANN_AGGR_STAT_Cannib": '*'},
                        properties: {color : "#e69b2f"},
                        displayName: "Cann Aggressor Statistical Case"
                    }
                }
            }
        }
    ]
}


//</editor-fold>

export const  CannibalizationSetStatAxis: IGraphAxis = {
    id: "Cann_Stat",
    name: "Statistical Case Cnb",
    renderOptions: {ui5: {
            resourceName: "CannibalizationStatAxisName",
            vizPropertiesAxis: {
                title: {
                    visible: true,
                    text: "Statistical Case"
                }
            },
            vizPropertiesPlotArea: {}
        }
    },
    metrics: [CNSMP_CANNIB_VICT_STAT_Cannib,
        CNSMP_CANNIB_AGGR_STAT_Cannib,
        CNSMP_INCR_STAT_UseBounds_Cannib,
        CNSMP_BASE_STAT_UseBounds_Cannib],
    defaultRenderedMetricIds: [
        CNSMP_CANNIB_VICT_STAT_Cannib.id,
        CNSMP_INCR_STAT_UseBounds_Cannib.id,
        CNSMP_BASE_STAT_UseBounds_Cannib.id
    ]

}

//</editor-fold>





export const CannibalizationSetAggressorAxisList: IGraphAxis[] = [
  CannibalizationSetUnitsAxis,
    CannibalizationSetRetailSalesAxis,
    CannibalizationSetWeightAxis,
    CannibalizationSetStatAxis,
  StdMerchadisingUnitsAxis,
  StdMerchadisingACVAxis
]

export const CannibalizationSetVictimAxisList: IGraphAxis[] = [
  CannibalizationSetUnitsAxis,
    CannibalizationSetRetailSalesAxis,
    CannibalizationSetWeightAxis,
    CannibalizationSetStatAxis,
  StdMerchadisingUnitsAxis,
  StdMerchadisingACVAxis
]
